import { render } from "./EditRosterDialog.vue?vue&type=template&id=81c690be"
import script from "./EditRosterDialog.vue?vue&type=script&lang=js"
export * from "./EditRosterDialog.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "81c690be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81c690be', script)) {
    api.reload('81c690be', script)
  }
  
  module.hot.accept("./EditRosterDialog.vue?vue&type=template&id=81c690be", () => {
    api.rerender('81c690be', render)
  })

}

script.__file = "src/components/roster/EditRosterDialog.vue"

export default script